module.exports = __webpack_public_path__ + "static/media/screws.92e8eee8.png";